$(function () {
  'use strict';

  //slider
  var sliderOpt = {
    infinite: true,
    arrows: true,
    dots: true,
    dotsClass: 'sliderDots',
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    centerMode: true,
    //centerPadding: '48px',
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: 'cubic-bezier(0,1,.75,1.1)',
    lazyLoad: 'progressive',
    pauseOnFocus: false,
    pauseOnHover: false,
    prevArrow: '<div class="carousel--prev"></div>',
    nextArrow: '<div class="carousel--next"></div>',
    responsive: [
      {
        breakpoint: 901,
        settings: {
          slidesToShow: 1,
          centerPadding: '25%',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: '50px',
        },
      },
    ],
  };
  var slider = $('.slider-section').slick(sliderOpt);
});

window.addEventListener('load', async () => {
  let isMobile = false;

  // スマホ判定
  if (navigator.userAgentData) {
    try {
      const ua = await navigator.userAgentData.getHighEntropyValues(['mobile']);
      isMobile = ua.mobile === true;
    } catch {}
  }

  // スマホ判定 fallback
  if (!navigator.userAgentData) {
    isMobile = /Android|iPhone|iPod|Mobile/i.test(navigator.userAgent);
  }

  //検証用
  //isMobile = true;

  const lists = document.querySelectorAll('.collection__list');

  // 📱 スマホ処理
  if (isMobile) {
    lists.forEach((el) => {
      el.classList.remove('splide');
      el.classList.add('scroller');
    });
    return; // ← Splide 初期化を完全に止める
  }

  // 💻 PC / タブレットだけ Splide
  lists.forEach((el) => {
    const splide = new Splide(el, {
      autoplay: false,
      type: 'slide',
      rewind: false,
      pauseOnHover: false,
      speed: 1000,
      perPage: 4,
      perMove: 3,
      updateOnMove: false,
      pagination: false,
      gap: '15px',
      breakpoints: {
        1000: {perPage: 3},
        768: {perPage: 2},
        640: {perPage: 1, gap: '0px'},
      },
    });

    const toggleArrows = () => {
      const arrows = splide.root.querySelector('.splide__arrows');
      if (!arrows) return;

      arrows.style.display = splide.length <= splide.options.perPage ? 'none' : '';
    };

    splide.on('mounted updated resized refresh', toggleArrows);
    splide.mount();
  });
});

//Also Boughtの高さを揃える
(() => {
  const CONTAINER_SEL = '.cbb-also-bought-slider-container';
  const ITEM_SEL = '.cbb-also-bought-product';

  // 高さを揃える本体
  const equalizeHeights = (container) => {
    if (!container) return;

    const items = Array.from(container.querySelectorAll(ITEM_SEL));
    if (!items.length) return;

    // いったんリセット（再計算できるように）
    items.forEach((el) => {
      el.style.height = '';
    });

    // 高さ計測（画像などで後から伸びる可能性があるので getBoundingClientRect を使用）
    let max = 0;
    items.forEach((el) => {
      const h = el.getBoundingClientRect().height;
      if (h > max) max = h;
    });

    // 0やNaN防止
    if (!max || !Number.isFinite(max)) return;

    // 揃える
    items.forEach((el) => {
      el.style.height = `${Math.ceil(max)}px`;
    });
  };

  // 画像読み込み完了後に1回揃える（遅延ロード対策）
  const bindImageLoadRecalc = (container) => {
    const imgs = Array.from(container.querySelectorAll('img'));
    imgs.forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => equalizeHeights(container), {once: true});
    });
  };

  // containerが既にある場合も対応
  const initForContainer = (container) => {
    equalizeHeights(container);
    bindImageLoadRecalc(container);

    // 生成直後にDOMが追加され続けるケース対策で、少し遅らせても再計算
    requestAnimationFrame(() => equalizeHeights(container));
    setTimeout(() => equalizeHeights(container), 200);
    setTimeout(() => equalizeHeights(container), 800);
  };

  // すでに存在するなら即実行
  const existing = document.querySelector(CONTAINER_SEL);
  if (existing) initForContainer(existing);

  // まだ無いなら監視して生成を検知
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;

        // 追加されたnode自身がcontainerの場合
        if (node.matches?.(CONTAINER_SEL)) {
          initForContainer(node);
          continue;
        }

        // 追加されたnodeの中にcontainerが含まれる場合
        const container = node.querySelector?.(CONTAINER_SEL);
        if (container) {
          initForContainer(container);
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // リサイズでも再計算（レスポンシブで高さ変わる用）
  window.addEventListener('resize', () => {
    const container = document.querySelector(CONTAINER_SEL);
    if (container) equalizeHeights(container);
  });
})();
